import authRules from '../authRules';

const editTour = (user) => {
  const { tour } = user.securityLevels;
  if (tour >= authRules.editTour.tour) {
      return true;
  } else {
      return false;
    }
  }


export default editTour;



// WEBPACK FOOTER //
// ./src/AuthLogic/rules/editTour.js